const eProfileView = {
  ProfileList: 1,
  EditProfile: 2,
  CreateProfile: 3
};

export default eProfileView;
